export const HeaderStaticTextStyles = Object.freeze({
  BIG_TOP: 'bigTop',
  OPAQUE: 'opaque',
});
